import { Title, UnstyledButton } from "@mantine/core";
import { Link, LinkProps } from "@tanstack/react-router";
import { SidebarItem, SidebarItemProps } from "shared/components/global/Sidebar/SidebarItem";
import classes from "shared/components/global/Sidebar/SidebarItem.module.css";

type SidebarLinkProps = {
    to: LinkProps["to"];
    hash?: string;
} & SidebarItemProps;

export const SidebarLink = ({ icon, label, to, hash, onClick }: SidebarLinkProps) => {
    return (
        <Link to={to} hash={hash} onClick={onClick} tabIndex={-1}>
            {({ isActive }) => {
                return <SidebarItem isActive={isActive} icon={icon} label={label} />;
            }}
        </Link>
    );
};

type SidebarSubLinkProps = Omit<SidebarLinkProps, "icon">;

export const SidebarSubLink = ({ label, to, hash, onClick }: SidebarSubLinkProps) => (
    <Link to={to} hash={hash} onClick={onClick} activeOptions={{ includeHash: !!hash }} tabIndex={-1}>
        {({ isActive }) => {
            return (
                <div style={{ margin: "0 var(--mantine-spacing-sm)" }}>
                    <UnstyledButton
                        size="sm"
                        w="100%"
                        pl="md"
                        style={{ justifyContent: "flex-start" }}
                        onClick={onClick}
                        className={classes.item}
                        data-active={isActive || undefined}
                    >
                        <Title order={2} fz="medium" fw="medium">
                            {label}
                        </Title>
                    </UnstyledButton>
                </div>
            );
        }}
    </Link>
);
